<template>
  <auth-layout>
    <section class="text-center">
      <h1 class="text-2pxl lg:text-2xl font-mulish font-black uppercase">
        {{ APP_NAME }} staff VERIFICATION
      </h1>
      <h5 class="text-sm lg:text-base font-semibold text-oneGray">
        Enter email or phone to proceed
      </h5>
    </section>

    <form @submit.prevent="sendToken">
      <div>
        <label for="emailOrPhone">Username</label>
        <input
          id="emailOrPhone"
          type="text"
          class="input"
          v-model="form.emailOrPhone"
          placeholder="enter email or phone number"
        />
      </div>

      <div class="mt-7">
        <button
          type="submit"
          class="bg-oneGreen text-white rounded-lg py-4 text-sm lg:text-2pxl font-semibold w-full flex justify-center items-center gap-4"
          :disabled="!emailOrPhoneReady || logging"
        >
          <spinner class="" v-if="logging"></spinner>
          <span>Proceed</span>
        </button>
      </div>
    </form>

    <section
      class="flex flex-col justify-center items-center mt-9 gap-5 text-xs lg:text-sm font-semibold"
    >
      <p class="">
        <router-link :to="{ name: 'Login' }" class="underline text-blue-500">
          Remembered password ?
        </router-link>
      </p>

      <p class="">
        Don't have an account?
        <router-link :to="{ name: 'Signup' }" class="text-oneGreen">
          Register
        </router-link>
      </p>
    </section>
  </auth-layout>
</template>

<script>
import AuthLayout from "@/layouts/AuthLayout.vue";

export default {
  name: "ForgotPassword",

  components: {
    AuthLayout,
  },

  data() {
    return {
      form: {
        emailOrPhone: null,
      },
      logging: false,
    };
  },

  computed: {
    emailOrPhoneReady() {
      return (
        this.form.emailOrPhone &&
        (/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(this.form.emailOrPhone) ||
          /^(\+[\d]{1,13}|0[\d]{1,11})$/.test(this.form.emailOrPhone))
      );
    },
  },

  methods: {
    async sendToken() {
      try {
        if (!this.emailOrPhoneReady) {
          this.$swal({
            icon: "error",
            text: "Please enter your email and password",
          });
          return;
        }
        this.logging = true;

        const { nx } = this.$route.query;
        let url = "/employee/send-otp";

        if (nx === "Create Password") {
          url = "/auth/forgot-password";
        }

        const res = await this.$http.post(url, this.form, {
          headers: { noauth: true },
        });

        this.logging = false;
        if (!res) {
          return;
        }

        const { data } = res;
        this.$store.commit("general/saveUser", {
          user: { ...data.data, emailOrPhone: this.form.emailOrPhone },
        });

        this.$swal({
          icon: "success",
          text: data.message,
        });

        // the go to code verification
        this.$router.push({
          name: "Verify Otp",
          query: { nx },
        });
      } catch (error) {
        this.logging = false;
      }
    },
  },
};
</script>

<style scoped>
form {
  @apply mx-auto w-full mt-11 lg:mt-14;
  max-width: 35rem;
}
</style>
